// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Gk-z","breadcrumbItem":"Hk-z","hideOnMobile":"Ik-z"};